{
    const menuItems = document.querySelectorAll('.menu-li');
    const subMenuItems = document.querySelectorAll('.sub-menu-li');

    new SV.HoverIntent(menuItems, {
        onEnter(targetItem) {
            targetItem.classList.add('active');
            document.body.classList.remove('menu-open');
        },
        onExit(targetItem) {
            targetItem.classList.remove('active');
            document.body.classList.remove('menu-open');
        },
        exitDelay: 200,
        interval: 50,
        sensitivity: 7,
    });

    document.querySelectorAll('.sub-menu').forEach(subMenu => {
        let unlockTimer = null;
        subMenu.addEventListener('mouseenter', () => {
            unlockTimer = setTimeout(() => {
                subMenu.querySelectorAll('.sub-menu-li').forEach(el => {
                    el.classList.remove('lg:pointer-events-none');
                });
            }, 150);
        });
        subMenu.addEventListener('mouseleave', () => {
            clearTimeout(unlockTimer);
        });
    });

    const mainContent = document.querySelector('#main-content');
    if (mainContent) {
        mainContent.addEventListener('mouseenter', () => {
            document.querySelectorAll('.sub-menu-li').forEach(el => {
                el.classList.remove('lg:pointer-events-none');
            });
        });
    }

    let menuFocusTimer = null;

    menuItems.forEach(item => {
        item.addEventListener('focusin', () => {
            clearTimeout(menuFocusTimer);
            menuItems.forEach(el => {
                if (el !== item) el.classList.remove('active');
            });
            item.classList.add('active');
            document.body.classList.remove('menu-open');
        });

        item.addEventListener('focusout', (e) => {
            if (item.contains(e.relatedTarget)) return;
            menuFocusTimer = setTimeout(() => {
                item.classList.remove('active');
                document.body.classList.remove('menu-open');
            }, 200);
        });
    });

    let exitTimer = null;

    subMenuItems.forEach(item => {
        item.addEventListener('mouseenter', () => {
            clearTimeout(exitTimer);
            item.closest('ul').querySelectorAll(':scope > .sub-menu-li.active').forEach(el => {
                el.classList.remove('active');
            });
            item.classList.add('active');
            if (!item.closest('.menu-li:nth-child(5)')) {
                document.body.classList.add('menu-open');
            }
        });

        item.addEventListener('mouseleave', () => {
            exitTimer = setTimeout(() => {
                item.classList.remove('active');
            }, 200);
        });
    });

    let subFocusTimer = null;

    subMenuItems.forEach(item => {
        item.addEventListener('focusin', () => {
            clearTimeout(subFocusTimer);
            item.closest('ul').querySelectorAll(':scope > .sub-menu-li.active').forEach(el => {
                el.classList.remove('active');
            });
            item.classList.add('active');
            if (!item.closest('.menu-li:nth-child(5)')) {
                document.body.classList.add('menu-open');
            }
        });

        item.addEventListener('focusout', (e) => {
            if (item.contains(e.relatedTarget)) return;
            subFocusTimer = setTimeout(() => {
                item.classList.remove('active');
            }, 200);
        });
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            menuItems.forEach(el => el.classList.remove('active'));
            subMenuItems.forEach(el => el.classList.remove('active'));
            document.body.classList.remove('menu-open');
            document.activeElement.blur();
        }
    });
}